module.exports = __webpack_public_path__ + "img/phone-no-2.961f9db0.svg";